module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page auth-page auth-tab no-top-nav no-side-space"
  }, [_c('v-container', {
    attrs: {
      "grid-list-item": "",
      "auth-card": "",
      "allChildrenCenter": "",
      "px-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "auth-card-wrapper": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [(!_vm.onMobile) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "auth-card-child": "",
      "left-card": "",
      "sign-in-info": ""
    }
  }, [(!_vm.onMobile) ? _c('div', [_c('img', {
    attrs: {
      "width": "40%",
      "src": "/static/images/nav_logo_primary.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-4 dflex align-center"
  }, [_c('h3', [_vm._v("Sign up")]), _vm._v(" "), _c('h3', {
    staticClass: "mx-3"
  }, [_vm._v("or")]), _vm._v(" "), _c('h3', [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Login")])], 1)])]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center auth-img-wrapper"
  }, [(_vm.activeTab == 'everyone') ? _c('img', {
    attrs: {
      "width": "70%",
      "src": "/static/images/new_signup_img.svg",
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "width": "70%",
      "src": "/static/images/new_signup_img2.svg",
      "alt": ""
    }
  })])], 1) : _vm._e(), _vm._v(" "), (!_vm.register_success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "lg4": "",
      "auth-card-child": "",
      "right-card": "",
      "sign-in-info": ""
    }
  }, [(_vm.onMobile) ? _c('h2', {
    staticClass: "text-xs-center mb-4"
  }, [_vm._v("Sign Up")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "switch-btn-wrapper __collapsed",
    class: {
      'justify-center': _vm.onMobile
    }
  }, [_c('v-btn', {
    staticClass: "ml-0 switch-btn transparent text-btn px-3",
    class: [_vm.activeTab == 'everyone' ? 'black--text border-dark' : 'grey--text'],
    attrs: {
      "depressed": "",
      "round": _vm.activeTab == 'everyone'
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 'everyone'
      }
    }
  }, [_vm._v("\n            Listener\n          ")]), _vm._v(" "), (!_vm.onMobile) ? _c('v-spacer') : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-0 switch-btn transparent text-btn px-3",
    class: [_vm.activeTab == 'artistBrand' ? 'black--text border-dark' : 'grey--text'],
    attrs: {
      "depressed": "",
      "round": _vm.activeTab == 'artistBrand'
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 'artistBrand'
      }
    }
  }, [_vm._v("\n            Artist / Brand\n          ")])], 1), _vm._v(" "), (_vm.activeTab == 'everyone') ? _c('div', {
    staticClass: "everyone_tab"
  }, [_c('ListenerRegister')], 1) : _vm._e(), _vm._v(" "), (_vm.activeTab == 'artistBrand') ? _c('div', {
    staticClass: "artistBrand_tab"
  }, [_c('InviteRegister', {
    on: {
      "invite-mode": _vm.setInviteMode
    }
  })], 1) : _vm._e()]) : _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "auth-card-child": "",
      "right-card": "",
      "sign-in-info": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('b', [_vm._v("Check your email for confirmation")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-btn', {
    staticClass: "app-blue white--text",
    attrs: {
      "round": "",
      "depressed": ""
    }
  }, [_vm._v("Open email")])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71640cd4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/auth/authTab/index.vue
// module id = 1771
// module chunks = 180